















import Vue from "@/shared/node_modules/vue";
import Component from "@/shared/node_modules/vue-class-component";
import { Settings } from "@/shared/core/services/configService";
import { CrudService } from "@/shared/core/services/crudService";

@Component({})
export default class BookingConfirmPage extends Vue {
  state: string = "loading";
  message: string = "";

  async created() {
    const token = (this.$route.params.token as string) || "";
    const url = `${Settings.HostName}/api/publicbookings/confirm`;
    const res = await new CrudService().httpPost(url, { token });
    if (res != null && res.ok === true) {
      this.message = this.$t("Your appointment has been confirmed").toString();
    } else {
      this.message = this.$t("This link is not valid").toString();
    }
    this.state = "message";
  }
}
